import React from "react"

class FinancialHeaderComponent extends React.Component {

	render() {
		return (
			<div className={"grant-header"}>
				<span className="project-title">
					{this.props.row.title}
				</span>
				<div className="actions">
					<div className="project-properties">
						<div className={"project-fctva "} style={this.props.row.type !== "PLUS" ? { color: "red" } : { color: "green" }}>{this.props.row.type}</div>
					</div>
				</div>
			</div>
		)
	}



}

export default FinancialHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/financial-header-component.js